import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHead = ({ chapter, eyebrow, title, sub, align = "left" }) => (
    <div className={align === "center" ? "text-center" : "text-left"}>
        <Reveal>
            <div
                className={`flex items-center gap-3 ${
                    align === "center" ? "justify-center" : ""
                }`}
            >
                <span className="h-px w-10 bg-[#00C6FF]/50" />
                <span className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
                    {eyebrow}
                </span>
            </div>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="mt-5 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                {title}
            </h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.16}>
                <p className="mt-4 max-w-2xl text-base text-slate-400 sm:text-lg">
                    {sub}
                </p>
            </Reveal>
        )}
    </div>
);
